import { useTranslation } from "react-i18next";
import { cn } from "../utils/misc";

type Props = {
    isBeforeTax: boolean;
    onChange: (value: boolean) => void;
}

function TaxStatusSelect({ isBeforeTax, onChange }: Props) {
    const { t } = useTranslation();
    const commonClass = "bg-[#eee] flex justify-center items-center px-3 font-semibold border border-l-0 border-white-light dark:border-[#17263c] dark:bg-[#1b2e4b]";

    return (
        <select value={isBeforeTax ? "before" : "after"}
            onChange={(e) => {
                if (onChange) {
                    onChange(e.target.value === "before");
                }
            }}
            className={cn(commonClass, "border rounded-md cursor-pointer ml-2 w-auto min-w-[120px] dark:bg-[#1b2e4b] form-select h-9 text-sm")} >
            <option value="before">{t("before_tax")}</option>
            <option value="after">{t("after_tax")}</option>
        </select>
    );
}

export default TaxStatusSelect
